function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "99",
  height: "210",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M49.5 209.674c23.472 0 42.5-10.074 42.5-22.5 0-12.427-19.028-22.5-42.5-22.5S7 174.747 7 187.174c0 12.426 19.028 22.5 42.5 22.5z",
  fill: "url(#paint0_linear_201_85)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99 202.674c0-27.614-22.162-50-49.5-50S0 175.06 0 202.674",
  fill: "url(#paint1_linear_201_85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52 0h-5v160h5V0z",
  fill: "url(#paint2_linear_201_85)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_201_85",
  x1: "49.5",
  y1: "164.674",
  x2: "49.5",
  y2: "209.674",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".25",
  stopColor: "#FFFE97",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F5F350"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_201_85",
  x1: "49.5",
  y1: "152.674",
  x2: "49.5",
  y2: "202.674",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".156",
  stopColor: "#B4FF86",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".786",
  stopColor: "#BEDAA9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_201_85",
  x1: "49.5",
  y1: "0",
  x2: "49.5",
  y2: "160",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".156",
  stopColor: "#B4FF86",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".786",
  stopColor: "#BEDAA9"
})))));